import React from "react";
import { useViewport, useVersion } from '../../../hooks';
import { CDHeader, CDHeaderV2, CDSocial, CDFooter } from '../../organisms/desktop';
import { CMHeader, CMHeaderV2, CMSocial, CMFooter } from '../../organisms/movil';

const View = ({ children } : any) => {

    const { width } = useViewport();
    const { version } = useVersion();

    // Debug: verificar versión y viewport
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
        console.log('View - Width:', width, 'Version:', version, 'Is Mobile:', width <= 850, 'Should use:', width <= 850 ? (version === 'v2' ? 'CMHeaderV2' : 'CMHeader') : (version === 'v2' ? 'CDHeaderV2' : 'CDHeader'));
    }

    // Para v2: SIEMPRE usar componentes desktop, sin importar el tamaño
    // Para v1: usar lógica normal (desktop > 850px, móvil <= 850px)
    if (version === 'v2') {
        // v2 siempre usa componentes desktop
        return (
            <>
                <CDHeaderV2 />
                { children }
                <CDSocial />
                <CDFooter />
            </>
        );
    }
    
    // v1 usa lógica normal
    return (
        width > 850 ?
            <>
                <CDHeader />
                { children }
                <CDSocial />
                <CDFooter />
            </>
            :
            <>
                <CMHeader />
                { children }
                <CMSocial />
                <CMFooter />
            </>
    );
}

export default View;